/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import IosSwitchMain from "../../components/iosSwitchMain";
import { SubAdmin } from "../../types/General";
import { formatDubaiDateTime } from "../../utils/dateTime";
import IosSwitch from "../../components/iosSwitch";

const SubadminList = ({
  data,
  setSelectedId,
  setOpenDelete,
  handleStatusChange,
}: {
  data: SubAdmin[];
  setSelectedId: (id: string) => void;
  setOpenDelete: (open: boolean) => void;
  handleStatusChange: (id: string) => void;
}) => {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            role="button"
            tabIndex={0}
            className="user_block click_action"
            onClick={() => navigate(`/manage-subadmin/detail/${row?.id}`)}
          >
            <figure>
              <img
                src={row?.profileImage || "/static/images/user_placeholder.png"}
                alt=""
              />
            </figure>
            <p>
              <b>{row?.name || "-"}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "email",
      headerName: "Email",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <p>{row?.email || "-"}</p>;
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "phone",
      headerName: "Phone Number",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>{`${row?.countryDialCode ? `+${row?.countryDialCode}` : ""} ${row?.phoneNumber || "-"}`}</p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "role",
      headerName: "Role",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <p>{row?.roles[0] || "-"}</p>;
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>{row?.createdAt ? formatDubaiDateTime(row?.createdAt) : "-"}</p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <IosSwitchMain
            checked={row?.isActive}
            onChange={() => handleStatusChange(row?.id)}
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => navigate(`/manage-subadmin/edit/${row?.id}`)}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setOpenDelete(true);
                  setSelectedId(row?.id);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={data}
        />
      </div>
    </>
  );
};

export default SubadminList;
